export default "__VITE_ASSET__DJ_zSN9u__"